import React from "react"
import styled from "styled-components/macro"
import {
  ErrorFourZeroThreeIcon
} from "@iconsGallery"

import Helmet from "react-helmet"

import { Button as MuiButton, Typography } from "@material-ui/core"
import { spacing } from "@material-ui/system"

import { useSelector } from "react-redux"
import { JSUtils } from "@utils"
import { findFirstAllowedPath, toAppPath } from "../../utils/allowedRoute"

const Button = styled(MuiButton)(spacing)

const Wrapper = styled.div`
  padding: ${(props) => props.theme.spacing(6)}px;
  text-align: center;
  background: transparent;

  ${(props) => props.theme.breakpoints.up("md")} {
    padding: ${(props) => props.theme.spacing(10)}px;
  }
`

function Page403() {
  const userProfileDetails = useSelector((state) => state.adminReducer.userProfileDetails) || {};
  const userPermAttr =
    useSelector((state) => state.adminReducer.userKeycloakAttributes) || {}

  const returnWeb = () => {
    const { sidebarRoutes } = require("../../routes")
    const nextPath = toAppPath(
      findFirstAllowedPath(sidebarRoutes, (route) =>
        JSUtils.getReadWritePermissions(route, userPermAttr).isReadAllowed
      ),
      {
        roleType: userProfileDetails?.roleType || "",
        sourceRole: localStorage.getItem("sourceRole") || "",
        tenantId: localStorage.getItem("tenantId") || "",
      }
    )
    window?.location?.replace(nextPath || "/")
  }

  return (
    <Wrapper>
      <Helmet title="403 Forbidden" />
      <ErrorFourZeroThreeIcon />
      <Typography component="h2" variant="h5" align="center" gutterBottom>
        Access Denied / Forbidden
      </Typography>
      <Typography component="h2" variant="body1" align="center" gutterBottom>
        You don't have permission to access this page
      </Typography>

      <Button
        variant="contained"
        color="secondary"
        mt={2}
        onClick={() => returnWeb()}
      >
        Return to website
      </Button>
    </Wrapper>
  )
}

export default Page403
